import { TabTypes } from "../../Transaction/CreateReceiptSubmission/enums";

export const tabOpts = [
  {
    label: "Menunggu persetujuan",
    name: TabTypes.OPEN,
  },
  {
    label: "Disetujui",
    name: TabTypes.CLOSE,
  },
  {
    label: "Ditolak",
    name: TabTypes.CANCEL,
  },
];

export enum ModalType {
  APPROVE = "APPROVE",
  REJECT = "REJECT",
  DETAIL = "DETAIL",
}
